import { memo, useEffect, useMemo, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { BzButton, BzModal, BzModalBody, BzModalFooter, BzModalHeader, BzTab, BzTabs, BzTabsContainer, BzTabsContent, BzToggleButton } from "../../../components";
import { Lumpsum } from '../../index';
import { useSelector, useDispatch } from "react-redux";
import { handleModal, handleModalData } from "../../../redux/actions/modals";
import { ORDER_TYPES } from "../../../utils/global_variables";


const defaultTabKey = 'lumpsum';

const objDropdownOptions = {
    folioNo: ['49914514', '6475832591', '6475832591', '647583282'],
    transactionTypes: ['Physical', 'Online', 'Test', 'Breeze_Test'],
    frequency: ['Test', 'Breeze_Test', 'Physical'],
    transferTo: ['ICIC-Tax Saver Fund-Growth'],
    switchTo: ['ICIC-Tax Saver Fund-Growth'],
};

const PlaceOrder = ({ fundToBuy, activeButtonToggleIndex, setActiveButtonToggleIndex, setIsShowMandateModal }) => {

    const dispatch = useDispatch();
    const modals = useSelector(state => state?.modals?.modals);
    const [activeTab, setActiveTab] = useState(defaultTabKey);
    const [amount, setAmount] = useState(0);
    const [quantity, setQuantity] = useState(0);
    const [installation, setInstallation] = useState(0);

    // {/* BT-118877 Breeze - Mutual Fund-Global Search : Vinit R : 21/10/2023 - Start */ }
    const objModalData = useSelector(state => state?.modals?.modalData);
    // {/* BT-118877 Breeze - Mutual Fund-Global Search : Vinit R : 21/10/2023 - End */ }

    const onCounterChange = (e, setCounter) => {
        setCounter(e.target.value);
    };

    const onAddition = (setCounter) => {
        setCounter(current => parseInt(current) + 1);
    };

    const onSubtraction = (counter, setCounter) => {
        if (counter > 0)
            setCounter(current => current - 1);
    };

    const handleClose = () => {
        dispatch(handleModal([{ "PLACE_MUTUAL_FUND_ORDER": false }]));
        dispatch(handleModalData({}))
    };

    const lumpsumFields = [
        { label: 'Amount', name: 'amount', type: 'counter', state: amount, onAddition: () => onAddition(setAmount), onSubtraction: () => onSubtraction(amount, setAmount), onCounterChange: (e) => onCounterChange(e, setAmount), message: 'Min. 500 in multiple of 1' },
        { label: 'Transaction', name: 'transaction', type: 'select', options: objDropdownOptions.transactionTypes },
        { label: 'Folio No.', name: 'folioNo', type: 'select', options: objDropdownOptions.folioNo }
    ];

    const sipFields = [
        { label: 'Quantity', name: 'quantity', type: 'counter', state: quantity, onAddition: () => onAddition(setQuantity), onSubtraction: () => onSubtraction(quantity, setQuantity), onCounterChange: (e) => onCounterChange(e, setQuantity), message: 'Min. 500 in multiple of 1' },
        { label: 'Frequency', name: 'frequency', type: 'select', options: objDropdownOptions.frequency },
        { label: 'No of Installation', name: 'installation', type: 'counter', state: installation, onAddition: () => onAddition(setInstallation), onSubtraction: () => onSubtraction(installation, setInstallation), onCounterChange: (e) => onCounterChange(e, setInstallation) },
        { dateLabel: 'Start Date', checkBoxLabel: 'Generate 1st installment today', type: 'date' },
        { label: 'Transaction', name: 'transaction', type: 'select', options: objDropdownOptions.transactionTypes },
        { label: 'Folio No', name: 'folioNo', type: 'select', options: objDropdownOptions.folioNo }
    ];
    const swpFields = [
        { label: 'Redeem by Amount', name: 'amount', type: 'counter', state: amount, onAddition: () => onAddition(setAmount), onSubtraction: () => onSubtraction(amount, setAmount), onCounterChange: (e) => onCounterChange(e, setAmount), message: 'Min. 500 in multiple of 1' },
        { label: 'Frequency', name: 'frequency', type: 'select', options: objDropdownOptions.frequency },
        { label: 'No of Installation', name: 'installation', type: 'counter', state: installation, onAddition: () => onAddition(setInstallation), onSubtraction: () => onSubtraction(installation, setInstallation), onCounterChange: (e) => onCounterChange(e, setInstallation) },
        { dateLabel: 'Start Date', checkBoxLabel: 'Generate 1st installment today', type: 'date' },
        { label: 'Transaction', name: 'transaction', type: 'select', options: objDropdownOptions.transactionTypes },
        { label: 'Folio No', name: 'folioNo', type: 'select', options: objDropdownOptions.folioNo }
    ];

    const stpFields = [
        { label: 'Transfer To', name: 'transfer', type: 'select', options: objDropdownOptions.transferTo },
        { label: 'Amount', name: 'amount', type: 'counter', state: amount, onAddition: () => onAddition(setAmount), onSubtraction: () => onSubtraction(amount, setAmount), onCounterChange: (e) => onCounterChange(e, setAmount), message: 'Min. 500 in multiple of 1' },
        { label: 'Frequency', name: 'frequency', type: 'select', options: objDropdownOptions.frequency },
        { label: 'No of Installation', name: 'installation', type: 'counter', state: installation, onAddition: () => onAddition(setInstallation), onSubtraction: () => onSubtraction(installation, setInstallation), onCounterChange: (e) => onCounterChange(e, setInstallation) },
        { dateLabel: 'Start Date', checkBoxLabel: 'Generate 1st installment today', type: 'date' },
        { label: 'Transaction', name: 'transaction', type: 'select', options: objDropdownOptions.transactionTypes },
        { label: 'Folio No', name: 'folioNo', type: 'select', options: objDropdownOptions.folioNo }
    ];

    const switchFields = [
        { label: 'Switch To', name: 'switch', type: 'select', options: objDropdownOptions.switchTo },
        { label: 'Amount', name: 'amount', type: 'counter', state: amount, onAddition: () => onAddition(setAmount), onSubtraction: () => onSubtraction(amount, setAmount), onCounterChange: (e) => onCounterChange(e, setAmount), message: 'Min. 500 in multiple of 1' },
        { label: 'Frequency', name: 'frequency', type: 'select', options: objDropdownOptions.frequency },
        { label: 'No of Installation', name: 'installation', type: 'counter', state: installation, onAddition: () => onAddition(setInstallation), onSubtraction: () => onSubtraction(installation, setInstallation), onCounterChange: (e) => onCounterChange(e, setInstallation) },
        { dateLabel: 'Start Date', checkBoxLabel: 'Generate 1st installment today', type: 'date' },
        { label: 'Transaction', name: 'transaction', type: 'select', options: objDropdownOptions.transactionTypes },
        { label: 'Folio No', name: 'folioNo', type: 'select', options: objDropdownOptions.folioNo }
    ];

    const placeOrderTypes = useMemo(() => [{
        id: 1,
        tabKey: "lumpsum",
        tabTitle: "Lumpsum",
        data: lumpsumFields,
    },
    {
        id: 2,
        tabKey: ORDER_TYPES.EQUITY_SIP,
        tabTitle: "SIP",
        data: sipFields,
    },
    ], [activeButtonToggleIndex, fundToBuy, amount, quantity, installation]);



    const sellOrderTypes = useMemo(() => [
        {
            id: 1,
            tabKey: "lumpsum",
            tabTitle: "Lumpsum",
            data: lumpsumFields,
        },
        {
            id: 2,
            tabKey: "swp",
            tabTitle: "SWP",
            data: swpFields,
        },
        {
            id: 3,
            tabKey: "stp",
            tabTitle: "STP",
            data: stpFields,
        },
        {
            id: 4,
            tabKey: "switch",
            tabTitle: "Switch",
            data: switchFields,
        },
    ], [activeButtonToggleIndex, fundToBuy, amount, quantity, installation]);

    useEffect(() => {
        setActiveTab(defaultTabKey);
    }, [activeButtonToggleIndex]);

    // {/* BT-118877 Breeze - Mutual Fund-Global Search : Vinit R : 21/10/2023 - Start */ }
    useEffect(() => {
        if (objModalData?.orderType === 'SIP') {
            setActiveTab(placeOrderTypes[1].tabKey)
        } else {
            setActiveTab(placeOrderTypes[0].tabKey)
        }
    }, [objModalData?.orderType])
    // {/* BT-118877 Breeze - Mutual Fund-Global Search : Vinit R : 21/10/2023 - End */ }

    return (
        <BzModal size='lg' show={modals['PLACE_MUTUAL_FUND_ORDER']} onHide={handleClose} centered>
            <Container fluid className='p-0'>

                <BzModalHeader className='modaltabs-header d-block px-3 pt-0'>
                    <Row className='g-0'>
                        <Col className='d-flex justify-content-start align-items-center'>
                            <BzTabs className='nav nav-tabs align-items-end'>
                                {activeButtonToggleIndex === 0 ?
                                    placeOrderTypes?.map(each => {
                                        return (<BzTab key={each.id} className='nav-link me-4 m-2'
                                            onClick={() => { setActiveTab(each.tabKey); }}
                                            isActive={each.tabKey === activeTab}
                                            tabKey={each.tabKey}>{each.tabTitle}</BzTab>);
                                    }) :
                                    activeButtonToggleIndex === 1 ?
                                        sellOrderTypes?.map(each => {
                                            return (<BzTab key={each.id} className='nav-link me-4 m-2'
                                                onClick={() => { setActiveTab(each.tabKey); }}
                                                isActive={each.tabKey === activeTab}
                                                tabKey={each.tabKey}>{each.tabTitle}</BzTab>);

                                        }) : null
                                }
                            </BzTabs>
                        </Col>
                        <Col md={4} className='d-flex justify-content-end align-items-center'>
                            <BzToggleButton
                                wrapperClassName='buysell-wrap'
                                leftButtonClassName={`btn btn-sm ${activeButtonToggleIndex === 0 ? 'btn-positive' : ''}`}
                                rightButtonClassName={`btn btn-sm ${activeButtonToggleIndex === 1 ? 'btn-negative' : ''}`}
                                leftButtonTitle="BUY" rightButtonTitle="SELL" activeButtonToggleIndex={activeButtonToggleIndex} setActiveButtonToggleIndex={setActiveButtonToggleIndex} />
                        </Col>
                        <Col md={1} className='d-flex justify-content-end align-self-center'>
                            <div onClick={handleClose} className='icon-16 icon-close icon-dark ms-3'></div>
                        </Col>
                    </Row>
                </BzModalHeader>

                <BzModalBody className='bdr-btm'>
                    <Row className='g-0 pb-3'>
                        <Col>
                            <BzTabsContainer>
                                {
                                    activeButtonToggleIndex === 0 ?
                                        placeOrderTypes.map((each) =>
                                            <BzTabsContent key={each.id} showDefault={each.tabKey === activeTab} isActive={each.tabKey === activeTab} tabKey={each.tabKey}>
                                                <Lumpsum data={each.data} fund={fundToBuy} activeButtonToggleIndex={activeButtonToggleIndex} />
                                            </BzTabsContent>
                                        )
                                        : activeButtonToggleIndex === 1 ?
                                            sellOrderTypes.map((each) =>
                                                <BzTabsContent key={each.id} showDefault={each.tabKey === activeTab} isActive={each.tabKey === activeTab} tabKey={each.tabKey}>
                                                    <Lumpsum data={each.data} fund={fundToBuy} activeButtonToggleIndex={activeButtonToggleIndex} />
                                                </BzTabsContent>
                                            ) : null
                                }
                            </BzTabsContainer>
                        </Col>
                    </Row>
                    <Row className='g-0 p-0 pb-2'>
                        <Col>
                            <div className='font-regular font-size2 color-text color-negative'>* The cut off time is 14:30:00 any order placed after this time will be reported on next business day</div>
                        </Col>
                    </Row>
                </BzModalBody>

                <BzModalFooter className='d-block'>
                    <Row className='g-0 pt-3'>
                        <Col md={10} className='d-flex justify-content-start align-items-center'>
                            <div className='d-flex align-items-center me-3'>
                                <div className='font-medium font-size4 color-text'>Mandate</div>
                                <div className='icon-16 icon-info icon-dark ms-2'></div>
                            </div>

                            <div className='d-flex align-items-center'>
                                {/* for Buy button*/}
                                <div className='d-flex justify-content-start align-items-center' onClick={() => { setIsShowMandateModal(true); }}>
                                    <div className='font-medium font-size4 color-textual-link-withicon cursor-pointer'>Add new mandate</div>
                                    <div className='icon-12 icon-add icon-primary ms-2'></div>
                                </div>

                                {/* for Sell button*/}
                                {/* <div className='d-flex justify-content-start align-items-center me-4'>                                        
                                        <div className='font-regular font-size4 color-subtext me-3'>Auto Debit from:</div>
                                        <div className='font-regular font-size4 color-text'>Axis Bank</div>                                           
                                    </div>
                                    <div className='d-flex justify-content-start align-items-center me-4'>                                       
                                        <div className='font-regular font-size4 color-subtext me-3'>Mandate ID:</div>
                                        <div className='font-regular font-size4 color-subtext'>7567328937</div>                                        
                                    </div>
                                    <div className='font-regular font-size4 color-text me-4'>Change</div> 
                                */}
                            </div>

                        </Col>
                        <Col md={2} className='d-flex justify-content-end'>
                            <BzButton className={`btn btn-md ${activeButtonToggleIndex === 0 ? 'btn-positive' : 'btn-negative'}`} disabled>PLACE ORDER</BzButton>
                        </Col>
                    </Row>
                </BzModalFooter>

            </Container>
        </BzModal>
    );

};
export default memo(PlaceOrder);